<template>
  <div>
    <!-- 登录表单 -->
    <el-form
      ref="loginForm"
      :rules="loginFormRules"
      :model="loginForm"
      class="form login-form"
    >
      <!-- 账号 -->
      <el-form-item prop="username">
        <el-input
          v-model.trim="loginForm.username"
          class="height-input"
          placeholder="请输入手机号"
        >
          <i slot="prefix" class="icon iconfont icon-zhanghao"></i>
        </el-input>
      </el-form-item>
      <!-- 密码 -->
      <el-form-item prop="password">
        <el-input
          v-model.trim="loginForm.password"
          class="height-input"
          placeholder="请输入密码"
          show-password
          @keyup.enter.native="onLogin"
        >
          <i slot="prefix" class="icon iconfont icon-mima"></i>
        </el-input>
      </el-form-item>
      <!-- 图形验证码 -->
      <el-form-item v-if="showGraphic" prop="captcha">
        <div class="flex">
          <el-input
            v-model.trim="loginForm.captcha"
            class="height-input flex-1"
            placeholder="请输入图形码"
            @keyup.enter.native="onLogin"
          />
          <graphic-image-button ref="graphicImageButton" style="heigth: 50px" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          class="login-button one-line"
          :loading="loading"
          type="primary"
          @click="onLogin"
        >
          登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { passwordLoginApi } from '@/api/user'
import GraphicImageButton from '@/components/GraphicImageButton'

export default {
  name: 'AccountLogin',

  components: {
    GraphicImageButton
  },

  props: {
    jumpPathByIdentity: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      // 登录表单数据
      loginForm: {
        username: '', // 账号
        password: '', // 密码
        captcha: '' // 图形验证码
      },
      // 是否记住密码
      remember: false,
      // 登录表单校验
      loginFormRules: {
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          }
        ],
        captcha: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: ['blur', 'change']
          }
        ]
      },
      // 登录按钮加载状态
      loading: false,
      showGraphic: false // 当登录失败5次时显示
    }
  },

  methods: {
    /**
     * 处理登录按钮点击事件
     */
    onLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return

        this.loading = true

        passwordLoginApi({
          username: this.loginForm.username,
          password: this.loginForm.password,
          'remember-me': this.remember,
          captcha: this.loginForm.captcha
        })
          .then(res => {
            this.jumpPathByIdentity(res.data.ac).finally(() => {
              this.loading = false
            })
          })
          .catch(err => {
            this.$message.error(err.data.message)
            // 密码输入错误超过5次，展示验证码
            if (err.data.data && err.data.data.captcha === true) {
              this.showGraphic = true
            }
            this.$refs.graphicImageButton &&
              this.$refs.graphicImageButton.onChangeGraphic()

            this.loading = false
          })
      })
    },

    /**
     * 忘记密码点击事件
     */
    onForget() {
      this.$router.push({ name: 'Forget' })
      // this.$emit('forget')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-form {
  width: 340px;

  .login-button {
    margin-top: 8px;
    height: 40px;
  }
}

.login-help {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px 0;
  font-size: 16px;

  ::v-deep .el-button {
    &.el-button--text {
      padding: 0;
    }
  }
}
</style>
